import { Signal } from '@angular/core';
import { StoreRemoval } from './model/registrations/store-removal';

export function updateRemovals(
  newRemovals: Partial<StoreRemoval>[],
  originalRemovals: Signal<Record<string, StoreRemoval>>
) {
  const original = originalRemovals();
  const updated = { ...original };

  newRemovals.forEach((removal) => {
    if (removal.id) {
      updated[removal.id] = { ...original[removal.id], ...removal } as StoreRemoval;
    }
  });

  return { removals: updated };
}
